import Component from '../abstracts/Component';

export default class SearchGuestOrderComponent extends Component {

  static get SELECTORS() {
    return {
      btnSearch: '.js-search-guest-order',
    };
  }

  searchOrderSubmit() {

    //ajax submit of search order form to manage errors
    const ctx=this;
    $('body').on('click.search-order',SearchGuestOrderComponent.SELECTORS.btnSearch,function (e) {
      e.preventDefault();
      let formSearchOrder = this.closest('form');
      const formData = ctx.getFormData(formSearchOrder);
      $.ajax({
        url: '/guest/return-request?search-guest-order=true',
        data: formData,
        method: 'POST',
        success: function (response) {
          if(response.hasError){
            $('.js-error-notification').removeClass('hidden');
            $(formSearchOrder).find('input').addClass('error');
          } else {
            $('.js-error-notification').addClass('hidden');
            $(formSearchOrder).find('input').removeClass('error');
            $(formSearchOrder).submit();
          }
        }
      })
    });

  }

  getFormData(formSearchOrder) {
    return $(formSearchOrder).serialize();
  }

  render() {
    super.render();
    this.searchOrderSubmit();
  }
}
